export const PITCH_DECK_LANDING_DIAGNOSTIC_STEPS = ['start', 'register'] as const

export type PitchDeckLandingDiagnosticStep = (typeof PITCH_DECK_LANDING_DIAGNOSTIC_STEPS)[number]

/** Older teaser steps. Resume URLs with these land on register instead of a blank modal. */
export const PITCH_DECK_LANDING_LEGACY_TEASER_STEPS = ['analyzing', 'report', 'diagnose', 'rewrite'] as const
